import { getProductShortName } from './productNames';

export function getSpecsGrouping(productShapeId: string): string {
  return getProductShortName(productShapeId);
}
